import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import {
  AbstractControl,
  FormControl,
  ReactiveFormsModule,
} from '@angular/forms';

@Component({
  selector: 'ui-form-switch',
  imports: [ReactiveFormsModule],
  templateUrl: './form-switch.component.html',
  styleUrl: './form-switch.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[attr.data-cy]': 'dataCy() || null' },
})
export class FormSwitchComponent {
  dataCy = input<string>('');
  control = input<AbstractControl>();
  placeholder = input<string>();
  class = input<string>();
  checked = input<boolean>();
  id = input<string>();
  changeInput = output<Event>();

  get formControl(): FormControl {
    return this.control() as FormControl;
  }

  change(event: Event) {
    this.changeInput.emit(event);
  }
}
